import React from 'react';
import { Button } from 'primereact/button';
import { FindUser } from '../../../../../../../../find-user-page/find-user';
import { UserType } from '../../../../../../../../../api/types/user/user-type';
import { UserSummaryType } from '../../../../../../../../../api/types/user/user-summary.type';

interface AddPermissionGroupUsersDialogContentProps {
  selectedUsers: UserSummaryType[];
  loading: boolean;
  onSelectedUsersChange: (users: UserSummaryType[]) => void;
  onApprove: (
    selectedUsers: UserSummaryType[],
    setLoading: (loading: boolean) => void,
  ) => Promise<void>;
  onHide: () => void;
}

export const AddPermissionGroupUsersDialogContent: React.FC<
  AddPermissionGroupUsersDialogContentProps
> = ({ selectedUsers, loading, onSelectedUsersChange, onApprove, onHide }) => {
  const handleApprove = async () => {
    await onApprove(selectedUsers, () => {
      //
    });
  };

  return (
    <>
      <FindUser
        onChange={onSelectedUsersChange}
        role={UserType.ADMINISTRATION}
        onApprove={onApprove}
        displayApprove={false}
      />
      <div
        style={{
          marginTop: '8px',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'left',
        }}
      >
        <Button
          style={{ height: '30px' }}
          label="ביטול"
          outlined
          onClick={onHide}
          disabled={loading}
        />
        <div style={{ marginRight: '8px' }} />
        <Button
          onClick={handleApprove}
          style={{ height: '30px' }}
          label="אישור"
          loading={loading}
          disabled={loading}
        />
      </div>
    </>
  );
};
